var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReportExportPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.607,
    height: 15.607,
    viewBox: "0 0 15.607 15.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-export-3604431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48600",
    "data-name": "Group 48600",
    transform: "translate(10.176 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48599",
    "data-name": "Group 48599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71126",
    "data-name": "Path 71126",
    d: "M338.673,0h-4.254a.588.588,0,0,0,0,1.176h3.666V4.843a.588.588,0,0,0,1.176,0V.588A.588.588,0,0,0,338.673,0Z",
    transform: "translate(-333.83)",
    fill: "#f45e29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48602",
    "data-name": "Group 48602",
    transform: "translate(6.039 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48601",
    "data-name": "Group 48601",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71127",
    "data-name": "Path 71127",
    d: "M207.505.172a.588.588,0,0,0-.832,0l-8.391,8.391a.588.588,0,1,0,.832.832L207.505,1A.588.588,0,0,0,207.505.172Z",
    transform: "translate(-198.11 0)",
    fill: "#f45e29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48604",
    "data-name": "Group 48604",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48603",
    "data-name": "Group 48603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71128",
    "data-name": "Path 71128",
    d: "M13.019,70.921a.588.588,0,0,0-.588.588v6.529H1.176V66.784H7.705a.588.588,0,0,0,0-1.176H.588A.588.588,0,0,0,0,66.2v12.43a.588.588,0,0,0,.588.588h12.43a.588.588,0,0,0,.588-.588V71.509A.588.588,0,0,0,13.019,70.921Z",
    transform: "translate(0 -65.608)",
    fill: "#f45e29"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportExportPrimary);
export default __webpack_public_path__ + "static/media/icon-report-export-primary.0764de91.svg";
export { ForwardRef as ReactComponent };